import { render, staticRenderFns } from "./govCont.vue?vue&type=template&id=1fc54a51&scoped=true&"
import script from "./govCont.vue?vue&type=script&lang=js&"
export * from "./govCont.vue?vue&type=script&lang=js&"
import style0 from "./govCont.vue?vue&type=style&index=0&id=1fc54a51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc54a51",
  null
  
)

export default component.exports